import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from './badge/badge.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BadgesConfig } from './badge/badges-config';

@NgModule({
  declarations: [BadgeComponent],
  imports: [CommonModule, NgbModule],
  exports: [BadgeComponent]
})
export class BadgeModule {}
